import type { ComponentProps } from "solid-js";
import { mergeProps, Show } from "solid-js";
import Text from "../../text/Text";
import { Icon } from "../../icon/Icon";
import { narrow } from "../../../utils/solidUtils";
import type { SelectOption } from "../../../types/Menu";
import TriggerLabel, { triggerAriaLabel } from "./TriggerLabel";

type PillSingleSelectTriggerProps<T> = {
  ariaLabel?: string;
  value: SelectOption<T> | null | undefined;
  disabled?: boolean;
  arkProps?: ComponentProps<"button">;
  class?: string;
};

const PillSingleSelectTrigger = <T,>(rawProps: PillSingleSelectTriggerProps<T>) => {
  const props = mergeProps({ disabled: false }, rawProps);
  return (
    <button
      {...props.arkProps}
      type="button"
      aria-label={triggerAriaLabel(props.ariaLabel, props.arkProps)}
      disabled={props.disabled}
      class="group flex max-w-46 items-center gap-x-1.5 rounded-sm bg-surface-subtle py-1 text-small-medium text-primary focus-visible:outline-default"
      classList={{
        [props.class ?? ""]: true,
        "pl-2": props.value?.variant === "icon",
        "pl-1.5": props.value?.variant !== "icon",
        "cursor-default pr-2": props.disabled,
        "cursor-pointer pr-1.5 open:bg-surface-subtle-hover hover:bg-surface-subtle-hover": !props.disabled,
      }}
    >
      <TriggerLabel label={props.ariaLabel} arkProps={props.arkProps} />
      <Show when={props.value}>
        {(value) => (
          <div class="flex min-w-0 items-center gap-x-1">
            <Show when={narrow(value(), (v) => v.variant === "icon")}>
              {(v) => <Icon class="shrink-0" name={v().icon.name} type="solid" size="xs" />}
            </Show>
            <Text as="span" truncate class="text-small-medium text-primary" text={value().label} />
          </div>
        )}
      </Show>

      <Show when={!props.disabled}>
        <Icon name="chevronDown" type="solid" size="md" class="shrink-0 icon-primary" />
      </Show>
    </button>
  );
};

export default PillSingleSelectTrigger;
